import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducer } from "@insite/client-framework/Store/Data/Pages/PagesReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { BillToModel, CountryModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import StoreCartState from "@store/Store/Reducers/StoreCartState";
import { Draft } from "immer";

const initialState: StoreCartState = {
    editedPoNumber: "",
};

const actions = {
    "Store/CheckoutShipping/SetPoNumber": (draft: Draft<StoreCartState>, action: { poNumber: string }) => {
        draft.editedPoNumber = action.poNumber;
    },
};

export const cartReducer = createTypedReducerWithImmer(initialState, actions);

(reducers as any).storeCartReducer = cartReducer;

export type StoreCartReducerState = {
    cartReducer: StoreCartState;
} & ApplicationState;

type Reducers = {
    cartReducer: typeof cartReducer;
};

export type StoreCartReducerActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
